exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head[data-v-3e5483da],\n.content[data-v-3e5483da] {\n  width: 100%;\n}\n.head[data-v-3e5483da] {\n  padding-bottom: 10px;\n}\n.content[data-v-3e5483da] {\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);

// exports
